import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { Option, hoursOptions } from '../helper';

interface Props {
  selectedValuesSpecific?: string[];
}

export interface Ref {
  selectedValues: Option[];
}

const DataSpecificFilter: ForwardRefRenderFunction<Ref, Props> = (
  { selectedValuesSpecific = [] },
  ref
) => {
  const [selectedValues, setSelectedValues] = useState<Option[]>([]);

  const handleChange = (value: any[]) => setSelectedValues(value);

  useImperativeHandle(ref, () => ({
    selectedValues,
  }));

  useEffect(() => {
    if (selectedValuesSpecific.length > 0 && hoursOptions) {
      const clonedSelectedValuesSpecific = [...selectedValuesSpecific];
      const foundElements = hoursOptions.filter(
        (el) =>
          clonedSelectedValuesSpecific.includes(el.value) ||
          clonedSelectedValuesSpecific.includes(el.label)
      );
      if (JSON.stringify(foundElements) !== JSON.stringify(selectedValues)) {
        setSelectedValues([...foundElements]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValuesSpecific]);

  return (
    <div className="granularity-specific-container">
      <Autocomplete
        multiple
        size="small"
        id="tags-outlined"
        filterSelectedOptions
        options={hoursOptions}
        value={selectedValues}
        onChange={(
          event: React.SyntheticEvent,
          value: any[],
          reason: any,
          details?: any
        ) => handleChange(value)}
        ListboxProps={{ style: { maxHeight: 150 } }}
        getOptionLabel={(option: any) => option.label}
        renderInput={(params) => <TextField {...params} label="Hours" />}
      />
    </div>
  );
};

export default forwardRef<Ref, Props>(DataSpecificFilter);
